import React from 'react';
import { Icon } from '../icons';
import UserMenu from './UserMenu';

function Sidebar({ sections, active, onSelect, badges = {}, collapsed = false, onToggleCollapse, onOpenSettings, user, onLogout }) {
  // Raggruppa le voci per `group` (superadmin ha piu' gruppi; i ruoli singoli
  // usano un unico gruppo "Gestione"). Preserva l'ordine di apparizione.
  const order = [];
  const byGroup = {};
  sections.forEach((s) => {
    const g = s.group || 'Gestione';
    if (!byGroup[g]) { byGroup[g] = []; order.push(g); }
    byGroup[g].push(s);
  });

  return (
    <>
      <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-brand">
          <div className="sidebar-logo"><Icon name="logo" size={22} strokeWidth={2} /></div>
          <div className="sidebar-brand-text">
            <strong>HIPLAAS</strong>
            <span>Manager</span>
          </div>
        </div>

        <nav className="nav" aria-label="Navigazione principale">
          {order.map((g) => (
            <React.Fragment key={g}>
              <div className="nav-label">{g}</div>
              {byGroup[g].map((s) => (
                <button
                  key={s.id}
                  className={`nav-item ${active === s.id ? 'active' : ''}`}
                  onClick={() => onSelect(s.id)}
                  aria-current={active === s.id ? 'page' : undefined}
                  title={collapsed ? s.label : undefined}
                  aria-label={collapsed ? s.label : undefined}
                >
                  <Icon name={s.icon} size={19} />
                  <span>{s.label}</span>
                  {badges[s.section] ? <span className="nav-badge">{badges[s.section]}</span> : null}
                </button>
              ))}
            </React.Fragment>
          ))}
        </nav>

        {/* Utente e uscita stanno qui, non nella barra in alto: l'header resta al
            titolo della sezione e alle notifiche. Un unico elemento cliccabile
            (avatar + nome) apre il menu con Impostazioni e uscita, invece di
            pulsanti sempre visibili — anche da collassata resta solo l'avatar. */}
        <div className="sidebar-foot">
          <UserMenu
            user={user}
            collapsed={collapsed}
            onOpenSettings={onOpenSettings}
            onLogout={onLogout}
          />
        </div>
      </aside>
      <button
        type="button"
        className="sidebar-toggle"
        onClick={onToggleCollapse}
        aria-label={collapsed ? 'Espandi menu' : 'Comprimi menu'}
        title={collapsed ? 'Espandi menu' : 'Comprimi menu'}
      >
        <Icon name="chevronRight" size={14} strokeWidth={2.2} />
      </button>
    </>
  );
}

export default Sidebar;
